import { render, staticRenderFns } from "./ErrorBar.vue?vue&type=template&id=621283a3&scoped=true&"
import script from "./ErrorBar.vue?vue&type=script&lang=js&"
export * from "./ErrorBar.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBar.vue?vue&type=style&index=0&id=621283a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621283a3",
  null
  
)

export default component.exports